<form *ngIf="user()" (ngSubmit)="changeLogin()" [formGroup]="changeLoginForm">
    <div style="width: 500px">
        <div class="title">Change Login</div>
        <app-alert/>
        <input autofocus class="field" formControlName="login" required type="text">
        <button [disabled]="!changeLoginForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Set login</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../assets/img/spinner.svg"/>
        </button>
    </div>
</form>